export const formatTime = (ts = null) => {
    if (!ts) return
    const xTime = new Date(ts);

    const formatDigit = (digit = 0) => {
        return !isNaN(digit) && digit < 9 ? `0${digit}` : digit
    }

    return formatDigit(xTime.getHours()) + ":" + formatDigit(xTime.getMinutes());
}